import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import DropDownListViewModel from '@/ViewModels/Controls/DropDownListViewModel';
import TextBoxViewModel from '@/ViewModels/Controls/TextBoxViewModel';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';

export default class FactorySelectorBoxViewModel extends ControlViewModel {
    private DropDownListViewModel = ComponentManager.getViewModel<typeof DropDownListViewModel>('DropDownListViewModel');
    private TextBoxViewModel = ComponentManager.getViewModel<typeof TextBoxViewModel>('TextBoxViewModel');
    private LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModel>('LabelViewModel');

    public tooltip: any;
    public invalidationText: any;
    public valueFactory: KnockoutObservable<string>;
    public valueParams: KnockoutObservable<string>;
    public value: KnockoutComputed<string>;
    public dropDownList: DropDownListViewModel;
    public textbox: TextBoxViewModel;

    /**
     * Das ViewModel für die ExpanderGroupBox
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);

        this.tooltip = this.paramOrDefault(params.tooltip);
        this.invalidationText = this.paramOrDefault(params.invalidationText);
        this.valueFactory = this.observableOrDefault('');
        this.valueParams = this.observableOrDefault('').extend({ rateLimit: { timeout: 500, method: 'notifyWhenChangesStop' } });

        this.value = this.defineComputed({
            read: () => {
                let f = this.valueFactory();
                let p = this.valueParams();

                if (!f) {
                    return '';
                }

                let ret = f;

                if (p) {
                    if (p.indexOf('?') === 0) {
                        ret += p;
                    } else {
                        ret += '?' + p;
                    }
                }

                return ret;
            },
            write: (newValue: any) => {
                let value = newValue || '';
                let values = value.split('?');
                let f = values[0];
                let p = values[1] ? values[1] : '';

                this.valueFactory(f);
                this.valueParams(p);
            }
        }, params.value);

        this.dropDownList = new this.DropDownListViewModel({
            factory: this.factory,
            isRequired: this.isRequired,
            isEnabled: this.isEnabled,
            isValid: this.isValid,
            isFocusable: this.isFocusable,
            tooltip: new this.LabelViewModel({
                ergName: this.tooltip
            }),
            invalidationText: this.invalidationText,
            value: this.valueFactory,
            optionLabel: ' ',
            height: 500,
            data: this.defineComputed(() => {
                let result = [];

                for (let factory of ComponentManager.getFactories()) {
                    result.push(factory);
                }

                return result.sort();
            }),
            parentLocator: this.locator,
            locator: 'factory'
        });

        this.textbox = new this.TextBoxViewModel({
            factory: this.factory,
            isRequired: this.isRequired,
            isEnabled: this.isEnabled,
            isValid: this.isValid,
            invalidationText: this.invalidationText,
            isFocusable: this.isFocusable,
            parentLocator: this.locator,
            locator: 'params',
            value: this.valueParams
        });
    }

    public resetValue(): void {
        this.value(null);
    }
}

ComponentManager.setViewModel('FactorySelectorBoxViewModel', FactorySelectorBoxViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');